import React from 'react';
import styled from 'styled-components';
import Linkify from 'react-linkify';

const StyledPre = styled.pre`
  font-size: 100%;
  margin-bottom: 0px;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  -ms-word-break: break-all;
  margin-top: 0px;
`;

// this is for Linkify. without this function, Linkify delimits url with @ charactor..
const urlRegex = new RegExp('^http(s|)://.+\\..+');
const Link = (props: { children: any }) => {
  const { children } = props;
  if (children.match(urlRegex)) {
    return (
      <a href={children} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  return children;
};

interface Props {
  children: any;
  color?: string;
  disableLinkify?: boolean;
}

export const Pre = (props: Props) => {
  const { children, color, disableLinkify } = props;
  return (
    <StyledPre style={{ color: color ? color : '#333' }}>
      {disableLinkify === true ? (
        children
      ) : (
        <Linkify component={Link}>{children}</Linkify>
      )}
    </StyledPre>
  );
};
